import React, { useMemo } from 'react'

const kb = 1024
const mb = kb * 1024
const gb = mb * 1024

export const SizeDisplay = ({ size }) => {
  const display = useMemo(
    () => {
      if (!size) {
        return 'not available'
      }

      if (size >= gb) {
        return `${(size / gb).toFixed(0)} GB`
      } else if (size >= mb) {
        return `${(size / mb).toFixed(0)} MB`
      } else if (size >= kb) {
        return `${(size / kb).toFixed(0)} KB`
      } else {
        return `${size.toFixed(0)} B`
      }
    },
    [size]
  )

  return (
    <React.Fragment>
      {display}
    </React.Fragment>
  )
}
